export function handleExportTables(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[export-table]');
	} else {
		var $cont = $(selector + ' [export-table]');
	}

	$cont.each(function (idx) {
		let $el = $(this);

		$el.on('click', function (event) {
			event.preventDefault()
			$.fn.tableExport.ignoreCSS = ".texp-ignore";

			var filename = $el.data('filename')
			if (typeof filename === 'undefined') {
				filename = 'k1-table-export.xlsx'
			}

			let $table = $el.closest("table")

			let tableId = (typeof $table.attr('id') !== 'undefined') ? $table.attr('id') : 'tableexport-1'

			var table = $table.tableExport({
				exportButtons: false,
				filename: filename,
				sheetname: 'export',
			});

			var exportData = table.getExportData();

			var xlsxData = exportData[tableId]['xlsx'];
			table.export2file(xlsxData.data, xlsxData.mimeType, xlsxData.filename, xlsxData.fileExtension, xlsxData.merges, xlsxData.RTL, xlsxData.sheetname)
		})
	});
}
